// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"styles_footerLinks__Q21xT","icon":"styles_icon__NqNLF","label":"styles_label__9HLaY","container":"styles_container__y6zdo"};